import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=11c64387&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c64387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c64387')) {
      api.createRecord('11c64387', component.options)
    } else {
      api.reload('11c64387', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=11c64387&scoped=true&", function () {
      api.rerender('11c64387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/components/SectionTitle.vue"
export default component.exports